"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BrowserLocalStorageService = void 0;
var inversify_1 = require("inversify");
var BrowserLocalStorageService = /** @class */ (function () {
    function BrowserLocalStorageService() {
    }
    Object.defineProperty(BrowserLocalStorageService.prototype, "getItem", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (key) {
            return localStorage.getItem(key);
        }
    });
    Object.defineProperty(BrowserLocalStorageService.prototype, "saveItem", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (key, value) {
            localStorage.setItem(key, value);
        }
    });
    Object.defineProperty(BrowserLocalStorageService.prototype, "removeItem", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (key) {
            localStorage.removeItem(key);
        }
    });
    BrowserLocalStorageService = __decorate([
        inversify_1.injectable()
    ], BrowserLocalStorageService);
    return BrowserLocalStorageService;
}());
exports.BrowserLocalStorageService = BrowserLocalStorageService;
//# sourceMappingURL=BrowserLocalStorageService.js.map